import { useEffect, useState } from "react";
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import _ from 'lodash';
import { Link } from "@/helpers/common_helper";
import { pagelink } from "@/config/site";
import { StarRate } from '@/components/section/starRate';

export default function Review(props) {
    const { t, possibleSuggestionList, suggestionData, title } = props;
    const maxStar = 5;

    return (
        <>
            {/* <div className="product-review-inner">
                {possibleSuggestionList.length > 0 ? <h3>{t('You_may_also_like_these')}</h3> : null }
                <div className="product-review-slide">
                    <Swiper
                        className={"mySwiper2"}
                        spaceBetween={142}
                        slidesPerView={3}
                        modules={[Navigation]}
                        navigation={{
                            nextEl: ".swiper-button-next2",
                            prevEl: ".swiper-button-prev2",
                        }}
                        breakpoints={{
                            // when window width is >= 320px
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 20
                            },
                            576: {
                                slidesPerView: 1,
                                spaceBetween: 20
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 50
                            },
                            // when window width is >= 480px
                            992: {
                                slidesPerView: 2,
                                spaceBetween: 142
                            },
                            // when window width is >= 640px
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 142,
                            }
                        }}
                    >
                        <div className="swiper-wrapper">
                            {
                                possibleSuggestionList.length > 0 ?
                                    _.map(possibleSuggestionList, psL => (
                                        <SwiperSlide key={psL.company_id}>
                                            <div className="swiper-slide">
                                                <div className="product-review-box">
                                                    <div className="image-holder">
                                                        <center>
                                                        <img src={process.env.NEXT_PUBLIC_FS_URL+psL.logo} alt="" className="img-fluid" style={{ width: '80%'}}/>
                                                        </center>
                                                    </div>
                                                    <div className="text-box">
                                                        <ul>
                                                            {_.map(_.range(0, parseInt(psL.rating)), fsc => (
                                                                <li key={fsc}><img src="/assets/images/fill-star-icon.png" alt="" /></li>
                                                            ))}
                                                            {_.map(_.range(0, maxStar - parseInt(psL.rating)), esc => (
                                                                <li key={esc}><img src="/assets/images/star-icon.png" alt="" /></li>
                                                            ))}
                                                        </ul>
                                                        <h4>
                                                            <img src="/assets/images/diamond-icon.png" alt="" /><span>{Number(psL.diamond_total).toFixed(0)}</span>, {t('Rank')} #99
                                                        </h4>
                                                        <Link href={pagelink.review.singleReview+psL.company_id}>
                                                            <a target="_blank">{t('View_more')}</a>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))
                                    :
                                    null
                            }
                        </div>
                    </Swiper>
                    <div className="swiper-button-next swiper-button-next2"><img src="/assets/images/like-right-arrow.png" alt="" className="img-fluid" /></div>
                    <div className="swiper-button-prev swiper-button-prev2"><img src="/assets/images/like-left-arrow.png" alt="" className="img-fluid" /></div>
                </div>
            </div> */}
            <section className='you-may-like-this '>
                <div className='custom_container'>
                    <div className="you-may-like-this-title">
                        <h3 className='custom_h3 custom_colorPrimary'>
                            { title ?? 'You may like this'}
                        </h3>
                    </div>
                </div>
                <div className="you-may-like-this-list custom_container_withoutPadding">
                    <Swiper
                        // slidesPerView={3.2}
                        // spaceBetween={30}
                        className="you-may-like-this-swiper"
                        centerInsufficientSlides={true}
                        breakpoints={{
                            320: {
                                slidesPerView: 1.1,
                                centeredSlides: true
                            },
                            375: {
                                slidesPerView: 1.5,
                                centeredSlides: false
                            },
                            465: {
                                slidesPerView: 2.1,
                                centeredSlides: false
                            },
                            1200: {
                                slidesPerView: 3.1
                            }
                        }}
                    >
                        {
                            _.map(suggestionData, ({ company_id, logo: company_logo, company_name, rank: ranking, total_diamond, positive_star, negative_star, link }) => (
                            // _.map(suggestionData, ({ company_id, company_logo, company_name, ranking, rating, total_diamond }) => (
                                <SwiperSlide key={company_id}>
                                    <div className='you-may-like-this-item'>
                                        <div className='you-may-like-this-item-image'>
                                            <img 
                                                src={ company_logo ? `${process.env.NEXT_PUBLIC_FS_URL}${company_logo}` : '/assets/images/article-image-demo.png' } 
                                                className='img-fluid w-100' 
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <StarRate rate={positive_star.length} />
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <div className='d-flex align-items-center'>
                                                <div className='custom_icon_size_small'>
                                                    <img src="/assets/images/diamond-user.svg" alt="" className="img-fluid w-100" />
                                                </div>
                                                <h3 className='custom_h3 custom_colorPrimary'>
                                                    {total_diamond},
                                                </h3>
                                            </div>
                                            <h4 className='custom_h4'>
                                                Rank #{ranking}
                                            </h4>
                                        </div>
                                        <Link href={`/review/company/${link}`}>
                                            <div className='you-may-like-this-item-button' style={{ cursor: 'pointer' }}>
                                                <h4 className='custom_h4 custom_colorWhite'>
                                                    {t('View_more')}
                                                </h4>
                                            </div>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                                // <div className='col' key={company_id}>
                                //     <div className='card h-100'>
                                //         <img src={ company_logo ? `${process.env.NEXT_PUBLIC_FS_URL}${company_logo}` : '/assets/images/article-image-demo.png' } className='card-img-top p-lg-5 p-3 pb-lg-3 img-fluid' style={{ aspectRatio: '4/3' }}></img>
                                //         <div className='card-body pb-0'>
                                //             <div className='row row-cols-lg-5 row-cols-6 col-md-8 col-10 mx-auto justify-content-center py-2 border-1 rounded border' style={{ boxShadow: '0.418px 2.971px 8.64px 0.36px rgb(12 12 12 / 11%)' }}>
                                //                 {
                                //                     _.map(
                                //                         _.concat(
                                //                             _.fill(positive_star, (<i className="fa-solid fa-star" style={{ color: '#e0a61c' }}></i>)),
                                //                             _.fill(negative_star, (<i className="fa-regular fa-star" style={{ color: '#e0a61c' }}></i>))
                                //                         ),
                                //                         (element, index) => (<div key={index} className='col-2'>{ element }</div>)
                                //                     )
                                //                     // _.fill(
                                //                     //     _.map(_.range(0, 5), (index) => (<div className='col-2'><i key={index} className="fa-solid fa-star" style={{ color: '#e0a61c' }}></i></div>)),
                                //                     //     <div className='col-2'><i className="fa-regular fa-star" style={{ color: '#e0a61c' }}></i></div>,
                                //                     //     rating
                                //                     // )
                                //                 }
                                //             </div>
                                //             <div className='row col-lg-11 col-8 mx-auto justify-content-center py-2'>
                                //                 <div className='row align-items-center col-xl-6 col-lg-11 col-11'>
                                //                     <img className='col-md-4 offset-md-0 col-sm-5 col-6 img-fluid' src="/assets/images/diamond-icon.png" width={32} height={32}/>
                                //                     <span className='col-md-8 offset-md-0 col-auto g-0 text-center text-lg-start fw-bolder fs-5' style={{ color: '#bb9b6a' }}>{Number(total_diamond).toFixed(0)}</span>
                                //                 </div>
                                //                 <div className='row align-items-center col-xl-6 col-lg-11 col-11'>
                                //                     <span className='col-6 fw-bolder text-center fs-5 g-0 text-sm-end'>Rank</span>
                                //                     <span className='col-6 fw-bolder text-center fs-5 text-sm-start'>#{Number(ranking).toFixed(0)}</span>
                                //                 </div>
                                //             </div>
                                //         </div>
                                //         <div className='card-footer border-0 pt-0'>
                                //             <div className='row col-8 mx-auto justify-content-center'>
                                //                 <Link href={`/review/company/${company_name.replace(/[\W_]+/g, '-').toLowerCase()}-${company_id}`}>
                                //                     <Button className='btn shadow-none login-btn-pill-bg btn-filled gradient-hover-effect border-0 d-flex align-items-center justify-content-center my-4 w-100'>View More</Button>
                                //                 </Link>
                                //             </div>
                                //         </div>
                                //     </div>
                                // </div>
                            ))
                        }
                    </Swiper>
                </div>
            </section>
        </>
    )
}